import { render, staticRenderFns } from "./PowerWriterLeft.vue?vue&type=template&id=1b10e1f2&scoped=true"
import script from "./PowerWriterLeft.vue?vue&type=script&lang=js"
export * from "./PowerWriterLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b10e1f2",
  null
  
)

export default component.exports